/** @jsx jsx */

import React, { Fragment as _, memo } from 'react';
import { css, jsx } from '@emotion/core';

import burger from 'assets/burger.svg';
import close from 'assets/close.svg';
import { VisuallyHidden } from 'components/UI/VisuallyHidden';
import { getButtonFocus } from 'styles/variables';

const width = '24px';
interface IHeader {
  currentTopicIndex: number;
  topics: any[];
  color?: string;
}

const Burger = memo(
  ({
    menu,
    color,
    onClick,
  }: {
    menu: boolean;
    color?: string;
    onClick?: any;
  }) => {
    // const Stack = () => (
    //   <div className="fader_-5s">
    //     <img
    //       src={burger}
    //       css={css`
    //         width: 30px;
    //       `}
    //     />
    //   </div>
    // );

    const Stack = () => (
      <div
        className="fader_-5s"
        css={css`
          width: ${width};
        `}
      >
        {[0, 1, 2].map(i => (
          <div
            key={i}
            css={css`
              width: ${width};
              height: 4px;
              background: ${color};
              margin: 2px 0;
            `}
          />
        ))}
      </div>
    );

    const X = () => (
      <div
        className="fader_1s"
        css={css`
          position: relative;
          left: -1px;
          top: -1px;
          width: ${width};
          height: ${width};
        `}
      >
        <img
          src={close}
          css={css`
            width: ${width};
          `}
        />
      </div>
    );

    return (
      <button
        id="burger-x"
        aria-haspopup="true"
        aria-expanded={menu}
        css={css`
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          width: ${width};
          height: ${width};
          cursor: pointer;
          z-index: 2;
          border: none;
          background: none;

          &:focus {
            ${getButtonFocus(color)}
          }
        `}
        onClick={onClick}
      >
        <VisuallyHidden>
          {menu ? 'Hide' : 'Show'} navigation menu
        </VisuallyHidden>
        {menu ? <X /> : <Stack />}
      </button>
    );
  },
  ({ menu, color }, { menu: _menu, color: _color }) => {
    if (color !== _color) return false;
    return menu === _menu;
  }
);

export default Burger;
